import {schema} from 'normalizr'


//const lib = new schema.Entity('lib')

const explib = new schema.Entity('explib')//, {library: lib})

const exp = new schema.Entity('experiment', {explibs: [explib]}, {idAttribute:'id'})
const run_schema = new schema.Entity('run', {ngsExp_set: [exp]})

export default run_schema
